<template>
  <div>
    <div :id="mapId" style="width: 100%; height: calc(100vh - 84px)" v-loading="loading"
      :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"></div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  name: "HeatLocaMap",
  props: {
    loading: {
      type: Boolean,
      default: () => true,
    },
    heatmapData: {
      type: Array,
      default: () => [{ lng: 120.168083, lat: 30.239672, count: 80 }],
    },
    fieldComparison: {
      type: Object,
      default: () => ({
        lng: "dknm_longitude",
        lat: "dknm_latitude",
        count: "dknm_scale",
      }),
    },
  },
  data() {
    return {
      loadingText: "拼命加载中",
      mapKey: 0, // 添加一个用于强制重新渲染的key
      mapId: `map-${uuidv4()}`,
      map: null,
      heatmap: null,
      loca: null, // LOCA 实例
      stationGeojson: {
        type: "FeatureCollection",
        features: [],
      },
    };
  },
  watch: {
    heatmapData: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.initLoca();
        }
      },
    },
  },
  mounted() { },
  beforeDestroy() {
    if (this.map) {
      this.map.off("click", this.handleMapClick);
      // 销毁地图
      this.map.destroy();
      this.map = null;
    }
    // 重置 AMapLoader
    AMapLoader.reset();
  },
  methods: {
    // 使用 Promise 来处理 setGeojson
    setGeojson(arr) {
      return new Promise((resolve) => {
        // 假设 fieldComparison 是一个对象，包含 lng, lat, count 等属性的键名
        const { lng, lat, count } = this.fieldComparison;

        // 使用 map 生成新数组，同时处理可能未定义的属性
        this.stationGeojson.features = arr
          .map((i) => {
            // 检查经纬度是否存在，如果不存在则使用默认值 0
            const coordinates = [
              i[lng] != null ? i[lng] : 0,
              i[lat] != null ? i[lat] : 0,
            ];
            return {
              type: "Feature",
              properties: {
                // 检查 count 属性是否存在，如果不存在则使用默认值 0
                count: i[count] || 1,
                ...i,
              },
              geometry: {
                type: "Point",
                coordinates,
              },
            };
          })
          .filter((feature) =>
            feature.geometry.coordinates.every((coord) => coord != null)
          ); // 过滤掉经纬度不完整的数据

        // 数据处理完成后，resolve 这个 Promise
        resolve();
      });
    },
    initLoca() {
    this.loadingText = "拼命加载中"; // 设置加载提示文本
    setTimeout(() => {
      AMapLoader.load({
        key: "90adad8b348cb3860de492c32282f4af", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [],
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: "2.0.0", // Loca 版本，缺省 1.3.2
        },
      })
        .then((AMap) => {
          // 设置默认中心点
          const defaultCenter = [103.975223, 32.566319];
          this.map = new AMap.Map(this.mapId, {
            zoom: 5,
            center: defaultCenter, // 使用默认中心点创建地图
          });
          // 这里不再调用 initMapPlugins，而是直接处理数据
          this.setGeojson(this.heatmapData).then(() => {
            // 数据处理完成后初始化地图插件
            this.initMapPlugins();
            this.loading = false;
          });

        })
        .catch((e) => {
          this.loadingText = "地图加载失败，正在重试...";
          console.error("地图加载失败:", e);
          this.retryLoadMap();
        });
    }, 1000);
  },
    retryLoadMap() {
    if (this.retryCount < this.maxRetries) {
      this.retryCount++;
      this.loading = true;
      this.loadingText = `正在自动重启，拼命加载中 (重试 ${this.retryCount}/${this.maxRetries})`;
      setTimeout(() => {
        this.initLoca();
      }, 3000); // 3秒后重试
    } else {
      this.loadingText = "地图加载失败，已达到最大重试次数";
      console.error("地图加载失败，已达到最大重试次数");
    }
  },
    transformData(data) {
      return data.map(item => {
        return {
          lng: item.dknm_longitude,  // 使用经度字段
          lat: item.dknm_latitude,    // 使用纬度字段
          count: item.dknm_sow_inventory  // 使用sow_inventory字段作为count值
        };
      });
    },
    // 新方法，用于初始化地图插件
    initMapPlugins() {
      //图层切换控件
      this.map.plugin(["AMap.MapType"], () => {
        var type = new AMap.MapType({
          defaultType: 1, //初始化默认图层类型。 取值为0：默认底图 取值为1：卫星图 默认值：0
          showRoad: false, //叠加路网图层 默认值：false
          showTraffic: false, //叠加实时交通图层 默认值：false
        });
        this.map.addControl(type);
      });
      //地图操作工具条插件
      this.map.plugin(["AMap.ToolBar"], () => {
        var tool = new AMap.ToolBar({
          position: "LT",
          direction: true,
        });
        this.map.addControl(tool);
      });
      // eslint-disable-next-line no-undef
      var loca = new Loca.Container({
        map: this.map,
      });
      // eslint-disable-next-line no-undef
      var geo = new Loca.GeoJSONSource({
        data: this.stationGeojson,
        // url: 'https://a.amap.com/Loca/static/loca-v2/demos/mock_data/hz_house_order.json',
      });
      // eslint-disable-next-line no-undef
      var heatmap = new Loca.HeatMapLayer({
        // loca,
        zIndex: 10,
        opacity: 1,
        visible: true,
        zooms: [2, 22],
      });
      heatmap.setSource(geo, {
        radius: 10,
        unit: "px",
        height: 90,
        gradient: {
          0.1: "rgba(50,48,118,1)",
          0.2: "rgba(127,60,255,1)",
          0.4: "rgba(166,53,219,1)",
          0.6: "rgba(254,64,95,1)",
          0.8: "rgba(255,98,4,1)",
          1: "rgba(236,220,79,1)",
        },
        value: function (index, feature) {
          return feature.properties.count;
        },
        min: 0,
        max: 10, //4.6
        heightBezier: [0, 0.53, 0.37, 0.98],
      });
      loca.add(heatmap);

      // 贴地点，在zoom18可见
      // eslint-disable-next-line no-undef
      var scatter = new Loca.ScatterLayer({
        loca: loca,
        zIndex: 1000,
        zooms: [10, 20],
        opacity: 1,
      });
      var pointColors = [
        "#FFED6C",
        "#FFE647",
        "#FFDA0A",
        "#DBB707",
        "#B79705",
        "#937703",
        "#ffbc00",
      ];
      scatter.setSource(geo);
      scatter.setStyle({
        unit: "meter",
        size: function (index, feature) {
          const count = feature.properties.count;
          // 假设 count 值的范围是 0 到 100
          if (count <= 1000) {
            return [500, 500]; // 小
          } else if (count <= 2000) {
            return [1000, 1000]; // 中
          } else if (count <= 2000) {
            return [1500, 1500]; // 中
          } else if (count <= 3000) {
            return [2000, 2000]; // 中
          } else if (count <= 4000) {
            return [2500, 2500]; // 中
          } else if (count <= 5000) {
            return [3000, 3000]; // 中
          } else if (count <= 10000) {
            return [4000, 4000]; // 中
          } else {
            return [5000, 5000]; // 大
          }
        },
        color: function (index, feature) {
          const count = feature.properties.count;
          if (count <= 1000) {
            return pointColors[0]; // 小
          } else if (count <= 2000) {
            return pointColors[1]; // 中
          } else if (count <= 2000) {
            return pointColors[2]; // 中
          } else if (count <= 3000) {
            return pointColors[3]; // 中
          } else if (count <= 4000) {
            return pointColors[4]; // 中
          } else if (count <= 5000) {
            return pointColors[5]; // 中
          } else {
            return pointColors[6]; // 大
          }
        },
        // 优化点击区域，增加点击半径
        cursor: "pointer", // 鼠标悬停时显示手指图标
        opacity: 0.5, // 设置透明度为 0.5
      });
      loca.add(scatter);
      // 创建名称文本标记
      var nameText = new AMap.Text({
        text: "纯文本标记",
        anchor: "center", // 设置文本标记锚点
        draggable: true,
        cursor: "pointer",
        angle: 0,
        visible: false,
        bubble: true,
        offset: [0, -25],
        style: {
          padding: ".45rem 0.15rem",
          "margin-bottom": "1rem",
          "border-radius": ".25rem",
          "background-color": "#fff",
          width: "15rem",
          "border-width": 0,
          "box-shadow": "0 2px 6px 0 rgba(255, 255, 255, .3)",
          "text-align": "center",
          "font-size": "15px",
          color: "#333",
          opacity: 0.8, // 设置透明度为 0.8
        },
      });

      // 创建数量文本标记
      var countText = new AMap.Text({
        text: "纯文本标记",
        anchor: "center", // 设置文本标记锚点
        draggable: true,
        cursor: "pointer",
        angle: 0,
        visible: false,
        bubble: true,
        offset: [0, 5],
        style: {
          padding: ".45rem 0.15rem",
          "margin-bottom": "1rem",
          "border-radius": ".25rem",
          "background-color": "#fff",
          width: "15rem",
          "border-width": 0,
          "box-shadow": "0 2px 6px 0 rgba(255, 255, 255, .3)",
          "text-align": "center",
          "font-size": "15px",
          opacity: 0.8, // 设置透明度为 0.8
          color: "#333",
        },
      });
      nameText.setMap(this.map);
      countText.setMap(this.map);
      // text.setMap(this.map);
      this.map.on("mousemove", function (e) {
        var selectPoint = scatter.queryFeature(e.pixel.toArray());
        if (selectPoint) {
          // 更新名称文本标记
          nameText.setPosition(e.lnglat);
          nameText.setText(selectPoint.properties.name);
          nameText.show();

          // 更新数量文本标记位置和文本，并稍微错开位置以实现换行
          var countLngLat = [e.lnglat.lng, e.lnglat.lat - 0.001]; // 稍微偏移 y 坐标
          countText.setPosition(countLngLat);
          countText.setText("规模：" + selectPoint.properties.dknm_scale);
          countText.show();
        } else {
          // 隐藏文本标记
          nameText.hide();
          countText.hide();
        }
      });
      // 确保只绑定一次
      if (this.map) {
        this.map.on("click", (e) => {
          var selectPoint = scatter.queryFeature(e.pixel.toArray());
          if (selectPoint) {
            this.$emit("markerClick", selectPoint.properties);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Arial, sans-serif;
  text-align: center;
}

.loding {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
